import { NavLink, useLocation } from "react-router-dom";
import { useEffect } from "react";
import * as bootstrap from "bootstrap";

export default function MobileMenu() {
  const location = useLocation();

  useEffect(() => {
    const offcanvas = document.querySelector("#mobileMenu");
    if (offcanvas) {
      const bsOffcanvas = bootstrap.Offcanvas.getInstance(offcanvas);
      if (bsOffcanvas) bsOffcanvas.hide();
    }
  }, [location.pathname]);

  const getLinkClass = ({ isActive }) =>
    `mobile-nav-link ${isActive ? "mobile-nav-link-active" : ""}`;

  return (
    <>
      <style>{`
        #mobileMenu {
          width: 320px;
          background: #ffffff;
          color: #1f2937;
        }

        .mobile-menu-header {
          border-bottom: 1px solid rgba(0,0,0,0.08);
          background: #ffffff;
        }

        .mobile-menu-logo {
          max-width: 110px;
          height: auto;
        }

        .mobile-menu-subtitle {
          font-size: 0.78rem;
          color: #6b7280;
          margin-top: 2px;
        }

        .mobile-section-title {
          font-size: 0.72rem;
          text-transform: uppercase;
          letter-spacing: 0.08em;
          color: #6b7280;
          font-weight: 700;
          margin-bottom: 12px;
        }

        .mobile-nav-group {
          display: flex;
          flex-direction: column;
          gap: 8px;
        }

        .mobile-nav-link {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 14px 16px;
          border-radius: 14px;
          text-decoration: none;
          color: #111827;
          font-weight: 600;
          background: #f8fafc;
          border: 1px solid rgba(0,0,0,0.05);
          transition: all 0.22s ease;
        }

        .mobile-nav-link:hover {
          background: #eef2f7;
          color: #0C1E47;
        }

        .mobile-nav-link-active {
          background: #0C1E47;
          color: #ffffff !important;
          border-color: #0C1E47;
          box-shadow: 0 8px 20px rgba(12, 30, 71, 0.14);
        }

        .mobile-nav-link-active i {
          color: #ffffff;
        }

        .mobile-nav-link i {
          color: #6b7280;
          font-size: 0.9rem;
        }

        .mobile-cta-primary {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          padding: 14px 16px;
          border-radius: 14px;
          text-decoration: none;
          font-weight: 700;
          background: #0C1E47;
          color: #ffffff;
          border: 1px solid #0C1E47;
          transition: all 0.22s ease;
        }

        .mobile-cta-primary:hover {
          background: #16356f;
          color: #ffffff;
        }

        .mobile-cta-secondary {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 100%;
          padding: 14px 16px;
          border-radius: 14px;
          text-decoration: none;
          font-weight: 700;
          background: #ffffff;
          color: #0C1E47;
          border: 1px solid rgba(12, 30, 71, 0.12);
          transition: all 0.22s ease;
        }

        .mobile-cta-secondary:hover {
          background: #f8fafc;
          color: #0C1E47;
        }

        .mobile-contact-box {
          background: #f8fafc;
          border: 1px solid rgba(0,0,0,0.06);
          border-radius: 16px;
          padding: 16px;
        }

        .mobile-contact-link {
          display: block;
          text-decoration: none;
          color: #374151;
          font-size: 0.94rem;
          margin-bottom: 8px;
        }

        .mobile-contact-link:last-child {
          margin-bottom: 0;
        }

        .mobile-contact-link:hover {
          color: #0C1E47;
        }

        .mobile-close-btn {
          border: 0;
          background: transparent;
          color: #111827;
          font-size: 1.2rem;
          line-height: 1;
        }
      `}</style>

      <div
        className="offcanvas offcanvas-start"
        tabIndex="-1"
        id="mobileMenu"
        aria-labelledby="mobileMenuLabel"
      >
        <div className="offcanvas-header mobile-menu-header">
          <div>
            <img
              src="/logo192.png"
              alt="Logo THE BRIDGE"
              className="mobile-menu-logo"
              loading="lazy"
            />
            <div className="mobile-menu-subtitle">
              Véhicules, location et pièces détachées
            </div>
          </div>

          <button
            type="button"
            className="mobile-close-btn"
            data-bs-dismiss="offcanvas"
            aria-label="Close"
          >
            <i className="bi bi-x-lg"></i>
          </button>
        </div>

        <div className="offcanvas-body d-flex flex-column gap-4">
          <div>
            <div className="mobile-section-title">Navigation</div>

            <div className="mobile-nav-group">
              <NavLink to="/" className={getLinkClass}>
                <span>Accueil</span>
                <i className="bi bi-chevron-right"></i>
              </NavLink>

              <NavLink to="/catalogue" className={getLinkClass}>
                <span>Nos véhicules</span>
                <i className="bi bi-chevron-right"></i>
              </NavLink>

              <NavLink to="/locations" className={getLinkClass}>
                <span>Location</span>
                <i className="bi bi-chevron-right"></i>
              </NavLink>

              <NavLink to="/pieces-detachees" className={getLinkClass}>
                <span>Pièces détachées</span>
                <i className="bi bi-chevron-right"></i>
              </NavLink>

              <NavLink to="/a-propos" className={getLinkClass}>
                <span>À propos</span>
                <i className="bi bi-chevron-right"></i>
              </NavLink>

              <NavLink to="/contact" className={getLinkClass}>
                <span>Contact</span>
                <i className="bi bi-chevron-right"></i>
              </NavLink>
            </div>
          </div>

          <div>
            <div className="mobile-section-title">Accès rapide</div>

            <div className="d-flex flex-column gap-2">
              <NavLink to="/marques" className="mobile-cta-primary">
                Voir toutes les marques
              </NavLink>

              <a
                href="https://wa.me/22879309400"
                target="_blank"
                rel="noopener noreferrer"
                className="mobile-cta-secondary"
              >
                Contacter sur WhatsApp
              </a>
            </div>
          </div>

          <div className="mt-auto">
            <div className="mobile-section-title">Coordonnées</div>

            <div className="mobile-contact-box">
              <a href="tel:+22879309400" className="mobile-contact-link">
                +228 79 30 94 00
              </a>

              <a
                href="mailto:contact@thebridgeofworld.com"
                className="mobile-contact-link"
              >
                contact@thebridgeofworld.com
              </a>

              <div className="mobile-contact-link mb-0">Lomé, Togo</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
